import React from "react";
import { useDispatch, useSelector } from "react-redux";

import Grid from "../../assets/icons/Grid";
import List from "../../assets/icons/List";
import { setSortBy } from "../../slices/filter";
import { GRID, LIST } from "../collections/CollectionsContainer";

const ProductListingHeader = ({ length, activeView, setActiveView }) => {
  const { sortBy } = useSelector((state) => state.filter);
  const dispatch = useDispatch();

  async function handleSelect(e) {
    dispatch(setSortBy(e.target.value));
  }
  return (
    <div className="block w-full box-border">
      {/* ProductListingHeader */}
      {/* Select Option */}
      <div className="flex items-center justify-end mb-[10px] absolute lg:static top-0 right-0 z-[1]">
        <div className="flex items-center">
          <div className="grow items-center border-inherit mr-[30px] hidden lg:flex">
            <h5 className="text-base tracking-[0.4px] leading-7 w-[90px]">
              Sort by:
            </h5>
            <select
              className="min-w-[250px] w-full border-none focus:border-none outline-none font-bold"
              value={sortBy}
              onChange={handleSelect}
            >
              <option value="featured">Featured</option>
              {/* <option value="asc">Alphabatically A-Z</option>
              <option value="desc">Alphabatically Z-A</option> */}
              <option value="price_h">Price, low to high</option>
              <option value="price_l">Price, high to low</option>
              {/* <option value="date_asc">Date, old to new</option>
              <option value="date_desc">Date, new to old</option> */}
            </select>
          </div>
          <div className="relative flex justify-end items-center box-border rounded-[40px] w-full p-0 mx-auto h-[42px] z-[1]">
            <button
              className={`cursor-pointer border-inherit py-[10px] px-4 ml-[10px] rounded-full flex items-center justify-center 
              object-contain text-base
            ${
              activeView === GRID
                ? "bg-black text-white hover:bg-black/80 hover:text-white"
                : "bg-transparent text-black hover:text-black/80"
            }`}
              onClick={() => setActiveView(GRID)}
            >
              <Grid />
            </button>
            <button
              className={`cursor-pointer border-inherit py-[10px] px-4 ml-[10px] rounded-full flex items-center justify-center 
             object-contain text-base
            ${
              activeView === LIST
                ? "bg-black text-white hover:bg-black/80 hover:text-white"
                : "bg-transparent text-black hover:text-black/80"
            }`}
              onClick={() => setActiveView(LIST)}
            >
              <List />
            </button>
          </div>
        </div>
      </div>
      <p className="text-sm text-black/60 ml-[10px] tracking-[0.4px] leading-7 mb-2">
        Showing {length} of {length} results
      </p>
    </div>
  );
};

export default ProductListingHeader;
